import List from 'anchor-ui/list';
import ListItem from 'anchor-ui/list-item';
import defaultAvatar from "./../../assets/default_avatar.jpg"
import Button from 'anchor-ui/button';
import { IconClose } from 'anchor-ui/icons';
import Divider from 'anchor-ui/divider';
import { getSecondaryColor } from "../../utils/activeColor";
import { getFontStyle } from "../../utils/getFontStyle";
import { UserSettingsInterface } from "../../interfaces/userSettingsInterface";
import GoogleAdSense from "../GoogleAdSense";
import { checkUserIsRoyal } from "../../utils/checkSubscription";
import Card from 'anchor-ui/card';

const BlockedUsersPage = ({
  blockedUsers,
  handleBlockUser,
  userSettings,
  loggedInUser,
}: {
  blockedUsers: CometChat.User[] | null,
  handleBlockUser: (userId: string) => void;
  userSettings: UserSettingsInterface;
  loggedInUser: CometChat.User | null;
}) => {

  return (
    <>
      <Card style={{ height: '100%', width: '100%', backgroundColor: getSecondaryColor() }}>
        <GoogleAdSense
          adSlot="4191716780"
          style={{ display: 'inline-block', width: "984px", height: "121px" }}
          isRoyal={checkUserIsRoyal(loggedInUser?.getRole() ?? "")}
        />
      </Card>
      <br />

      <div className="flex">
        <div className="responsive-ad">
          <GoogleAdSense
            adSlot="6371157564"
            style={{ display: 'inline-block', width: "121px", height: "984px", paddingRight: "16px" }}
            isRoyal={checkUserIsRoyal(loggedInUser?.getRole() ?? "")}
          />
        </div>

        <div>
          <h2>Geblokkeerde gebruikers</h2>
          <p style={getFontStyle(userSettings.generalFontSize)}>
            Hier zie je de lijst van {blockedUsers && blockedUsers.length} gebruiker{blockedUsers ? (blockedUsers.length > 1 || blockedUsers.length === 0) && 's' : 's'} die je hebt geblokkeerd.
          </p>

          <div className='blocked-users-list'>
            <List
              style={{ backgroundColor: getSecondaryColor() }}
            >
              {blockedUsers ?
                blockedUsers.map((user, key) => {
                  return (
                    <div key={key}>
                      <ListItem
                        primaryText={user.getName()}
                        primaryTextStyle={getFontStyle(userSettings.generalFontSize)}
                        avatar={user.getAvatar() ?? defaultAvatar}
                        style={{ backgroundColor: getSecondaryColor() }}
                        rightButton={
                          <Button iconButton onClick={() => handleBlockUser(user.getUid())}>
                            <IconClose />
                          </Button>
                        }
                      />
                      <Divider />
                    </div>
                  );
                }) : <p>No users blocked.</p>
              }
            </List>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlockedUsersPage;